<template>
    <div class="col-sm-12 col-xl-6">
        <div class="card">
            <div class="card-header pb-0">
                <h3>Basic Tree</h3>
            </div>
            <div class="card-body">
                <div id="treeBasic">
                    <Tree :nodes="menu" :use-icon="false" draggable />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "vue3-tree";
import "vue3-tree/dist/style.css"
import treeMixin from "@/mixins/treeMixin"
export default {
    mixins: [treeMixin],
    components: {
        Tree
    },

}
</script>